/**
 * Alt kategori `key` değerleri ürün verisindeki `subcategory` alanı ile birebir eşleşmeli.
 * @see ./catalogTaxonomy.js — tek doğruluk kaynağı
 */
import {
  FOOD_MEGA_MENU_ORDER,
  CONSTRUCTION_SUBCATEGORIES,
  CLEANING_SUBCATEGORIES,
  PERSONAL_CARE_SUBCATEGORIES,
  SUBCATEGORY_LABEL_TR,
} from './catalogTaxonomy';
import { catalogChipLabel } from '../utils/catalogDisplay';

function toSubmenuEntries(keys) {
  return keys.map((key) => ({
    key,
    label_en: key,
    label_tr: SUBCATEGORY_LABEL_TR[key] || key,
  }));
}

function toFoodMegaMenuEntries() {
  return FOOD_MEGA_MENU_ORDER.map((key, idx) => {
    if (key == null) {
      return {
        key: `food-grid-spacer-${idx}`,
        gridSpacer: true,
        label_en: '',
        label_tr: '',
      };
    }
    return {
      key,
      label_en: key,
      label_tr: SUBCATEGORY_LABEL_TR[key] || key,
    };
  });
}

export const SUBMENU_BY_CATEGORY_ID = {
  food: toFoodMegaMenuEntries(),
  construction: toSubmenuEntries(CONSTRUCTION_SUBCATEGORIES),
  cleaning: toSubmenuEntries(CLEANING_SUBCATEGORIES),
  personal_care: toSubmenuEntries(PERSONAL_CARE_SUBCATEGORIES),
};

/**
 * @param {object} sub — { key, label_en, label_tr }
 * @param {string} lang — 'en' | 'fr' | 'es' | 'ar'
 * @param {function} [tl] — LanguageContext `tl` (needed for fr/es/ar via catalog map)
 * @param {string} [categoryKey] — parent e.g. "Food & Beverages" (Woo category)
 */
export function getSubmenuLabel(sub, lang = 'en', tl, categoryKey) {
  if (!sub || sub.gridSpacer) return '';
  const ck = (categoryKey || '').trim();
  if (typeof tl === 'function' && ck) {
    const chip = catalogChipLabel(sub.key, ck, tl);
    if (chip && chip !== sub.key) return chip;
  }
  if (lang === 'ar' && sub.label_tr) return sub.label_tr;
  return sub.label_en;
}
